import AlertContainer from "../../Componant/Ui Kit/Alert";

const Alert = () => {
  return (
    <div className="page-body">
      <AlertContainer />
    </div>
  );
};

export default Alert;
